import { useState } from 'react'
import { useNavigate } from 'react-router-dom'

export default function Onboarding() {
  const navigate = useNavigate()
  const [step, setStep] = useState(1)

  const handleNext = () => {
    setStep(2)
  }

  const handleFinish = () => {
    localStorage.setItem('onboardingComplete', 'true')
    window.location.href = '/dashboard'
  }

  // Step 1: Welcome
  if (step === 1) {
    return (
      <div className="min-h-screen bg-white flex items-center justify-center px-4">
        <div className="max-w-2xl w-full text-center">
          <img 
            src="https://static.lumi.new/94/94387bd69277769ec0567b4f6dbc1e0e.webp" 
            alt="Logo" 
            className="h-20 w-auto mx-auto mb-4"
          />
          <h1 className="text-5xl font-bold text-[#DC2626] mb-6">
            Bem-vindo à Unovalinks
          </h1>
          <p className="text-xl text-gray-600 mb-12 leading-relaxed">
            Em poucos passos você já começa! Você vai configurar sua conta e já poderá criar sua primeira proposta, e usufruir do que oferecemos.
          </p>
          <button
            onClick={handleNext}
            className="bg-[#DC2626] text-white px-12 py-4 rounded-xl text-lg font-semibold hover:bg-[#B91C1C] transition-colors"
          >
            Começar
          </button>
        </div>
      </div>
    )
  }

  // Step 2: Terms and Privacy
  return (
    <div className="min-h-screen bg-white py-8 px-4">
      <div className="max-w-4xl mx-auto">
        <div className="text-center mb-8">
          <img 
            src="https://static.lumi.new/94/94387bd69277769ec0567b4f6dbc1e0e.webp" 
            alt="Logo" 
            className="h-16 w-auto mx-auto mb-3"
          />
          <h2 className="text-3xl font-bold text-[#DC2626] mb-2">Termos e Políticas</h2>
          <p className="text-gray-600">Última etapa</p>
        </div>

        <div className="bg-white border-2 border-gray-100 rounded-2xl p-8 shadow-sm">

          <div className="max-h-96 overflow-y-auto border border-gray-200 rounded-lg p-6 mb-6 text-sm space-y-4">
            <div>
              <h3 className="text-xl font-bold text-[#DC2626] mb-4">TERMOS DE USO – UNOVALINKS</h3>
              <p className="text-gray-500 mb-4">Última atualização: 2026</p>

              <h4 className="font-bold text-gray-900 mt-4 mb-2">1. Aceitação dos termos</h4>
              <p className="text-gray-700">
                Ao acessar ou utilizar a plataforma Unovalinks, você concorda integralmente com estes Termos de Uso. Caso não concorde, não utilize a plataforma.
              </p>

              <h4 className="font-bold text-gray-900 mt-4 mb-2">2. Sobre a Unovalinks</h4>
              <p className="text-gray-700">
                A Unovalinks é uma plataforma digital que permite a criação, envio, gerenciamento e acompanhamento de propostas comerciais, contratos digitais e links de pagamento.
              </p>
              <p className="text-gray-700 mt-2">
                A Unovalinks não é parte das negociações entre usuários e seus clientes. Atuamos exclusivamente como ferramenta tecnológica.
              </p>

              <h4 className="font-bold text-gray-900 mt-4 mb-2">3. Responsabilidade do usuário</h4>
              <p className="text-gray-700 mb-2">O usuário é o único responsável por:</p>
              <ul className="list-disc list-inside text-gray-700 space-y-1">
                <li>Informações inseridas nas propostas</li>
                <li>Valores cobrados</li>
                <li>Serviços ou produtos oferecidos</li>
                <li>Cumprimento de acordos com seus clientes</li>
                <li>Emissão de notas fiscais, quando aplicável</li>
              </ul>

              <h4 className="font-bold text-gray-900 mt-4 mb-2">4. Pagamentos</h4>
              <p className="text-gray-700 mb-2">
                Os pagamentos são processados por plataformas terceiras (como Stripe ou similares).
              </p>
              <p className="text-gray-700 mb-2">A Unovalinks:</p>
              <ul className="list-disc list-inside text-gray-700 space-y-1">
                <li>Não armazena dados bancários</li>
                <li>Não garante prazos de repasse de terceiros</li>
                <li>Não se responsabiliza por taxas, bloqueios ou políticas das plataformas de pagamento</li>
              </ul>

              <h4 className="font-bold text-gray-900 mt-4 mb-2">5. Uso indevido</h4>
              <p className="text-gray-700 mb-2">É proibido utilizar a Unovalinks para:</p>
              <ul className="list-disc list-inside text-gray-700 space-y-1">
                <li>Atividades ilegais</li>
                <li>Golpes, fraudes ou esquemas</li>
                <li>Conteúdo falso, enganoso ou ofensivo</li>
              </ul>
              <p className="text-gray-700 mt-2">
                O descumprimento pode resultar em bloqueio ou exclusão da conta sem aviso prévio.
              </p>

              <h4 className="font-bold text-gray-900 mt-4 mb-2">6. Disponibilidade</h4>
              <p className="text-gray-700 mb-2">
                A plataforma é oferecida "como está", podendo passar por:
              </p>
              <ul className="list-disc list-inside text-gray-700 space-y-1">
                <li>Atualizações</li>
                <li>Manutenções</li>
                <li>Melhorias</li>
              </ul>
              <p className="text-gray-700 mt-2">Não garantimos funcionamento ininterrupto.</p>

              <h4 className="font-bold text-gray-900 mt-4 mb-2">7. Limitação de responsabilidade</h4>
              <p className="text-gray-700 mb-2">A Unovalinks não se responsabiliza por:</p>
              <ul className="list-disc list-inside text-gray-700 space-y-1">
                <li>Prejuízos financeiros</li>
                <li>Disputas entre usuários e clientes</li>
                <li>Perda de oportunidades</li>
                <li>Erros de terceiros</li>
              </ul>

              <h4 className="font-bold text-gray-900 mt-4 mb-2">8. Alterações</h4>
              <p className="text-gray-700">
                Os termos podem ser alterados a qualquer momento. O uso contínuo da plataforma implica aceitação automática.
              </p>
            </div>

            <div className="border-t-2 border-gray-200 pt-6 mt-6">
              <h3 className="text-xl font-bold text-[#DC2626] mb-4">POLÍTICA DE PRIVACIDADE – UNOVALINKS</h3>

              <h4 className="font-bold text-gray-900 mt-4 mb-2">1. Coleta de dados</h4>
              <p className="text-gray-700 mb-2">Coletamos apenas dados necessários para funcionamento:</p>
              <ul className="list-disc list-inside text-gray-700 space-y-1">
                <li>Nome</li>
                <li>E-mail</li>
                <li>Dados da empresa</li>
                <li>Informações de propostas</li>
              </ul>

              <h4 className="font-bold text-gray-900 mt-4 mb-2">2. Uso dos dados</h4>
              <p className="text-gray-700 mb-2">Utilizamos os dados para:</p>
              <ul className="list-disc list-inside text-gray-700 space-y-1">
                <li>Operar a plataforma</li>
                <li>Melhorar serviços</li>
                <li>Comunicação com o usuário</li>
              </ul>

              <h4 className="font-bold text-gray-900 mt-4 mb-2">3. Compartilhamento</h4>
              <p className="text-gray-700 mb-2">Seus dados não são vendidos.</p>
              <p className="text-gray-700 mb-2">Podem ser compartilhados apenas com:</p>
              <ul className="list-disc list-inside text-gray-700 space-y-1">
                <li>Plataformas de pagamento</li>
                <li>Serviços de infraestrutura (hospedagem, e-mail, segurança)</li>
              </ul>

              <h4 className="font-bold text-gray-900 mt-4 mb-2">4. Segurança</h4>
              <p className="text-gray-700">
                Utilizamos práticas padrão de segurança digital para proteger suas informações.
              </p>

              <h4 className="font-bold text-gray-900 mt-4 mb-2">5. Direitos do usuário</h4>
              <p className="text-gray-700 mb-2">Você pode:</p>
              <ul className="list-disc list-inside text-gray-700 space-y-1">
                <li>Solicitar exclusão da conta</li>
                <li>Solicitar remoção de dados</li>
                <li>Atualizar informações a qualquer momento</li>
              </ul>

              <h4 className="font-bold text-gray-900 mt-4 mb-2">6. Cookies</h4>
              <p className="text-gray-700 mb-2">A Unovalinks pode utilizar cookies para:</p>
              <ul className="list-disc list-inside text-gray-700 space-y-1">
                <li>Melhorar experiência</li>
                <li>Medir uso da plataforma</li>
              </ul>

              <h4 className="font-bold text-gray-900 mt-4 mb-2">7. Contato</h4>
              <p className="text-gray-700">Para qualquer dúvida:</p>
              <p className="text-gray-700 mt-2">
                <strong>suporte.nexias.unovalinks@gmail.com</strong> ou via suporte dentro da plataforma.
              </p>
            </div>

            <div className="border-t-2 border-gray-200 pt-6 mt-6">
              <h3 className="text-lg font-bold text-gray-900 mb-2">AVISO LEGAL</h3>
              <p className="text-gray-700">
                A Unovalinks atua exclusivamente como plataforma tecnológica de automação. Não participamos, intermediamos ou garantimos transações entre usuários e seus clientes.
              </p>
            </div>
          </div>

          <button
            onClick={handleFinish}
            className="w-full bg-[#DC2626] text-white py-4 rounded-lg font-semibold text-lg hover:bg-[#B91C1C] transition-colors mt-6"
          >
            Aceito e continuar para o painel
          </button>
        </div>
      </div>
    </div>
  )
}
